import Backbone from 'backbone';
import { on, off, getElement } from 'utils/mixins';
const $ = Backbone.$;

module.exports = Backbone.View.extend({
  tagName: 'div',

  template() {
    const icon_close = `${this.conf.domain}img/icon_close.png`;
    return `
            <style>
              .btn:hover {
                filter: brightness(80%);
              }
            </style>
            <div class="myConversation_header">
                Thông báo
                <img class="close btn_cancel" src="${icon_close}" >
            </div>
            <div class="myConversation_conten">Bạn có chắc chắn muốn kết thúc chat?</div>
            <div class="myConversation_footer">
              <div style="background-color:${this.conf.header_color}; color:${this.conf.text_header_color};" class="btn btn_agree">Đồng ý</div>
              <div class="btn btn_cancel">Huỷ bỏ</div>
            </div>`;
  },

  initialize(o) {
    _.bindAll(this, 'renderContent', 'handleCancelClick', 'handleAgreeClick');
    const model = this.model;
    model.view = this;
    this.conf = o.config || {};
    this.pfx = this.conf.stylePrefix || '';
  },

  handleCancelClick() {
    this.model.trigger('cancelClick');
  },

  handleAgreeClick() {
    this.model.trigger('agreeClick');
  },

  renderContent() {
    const { $el, model } = this;
    const that = this;
    $el.html(this.template());
    $el.find('.btn_cancel').on('click', this.handleCancelClick);
    $el.find('.btn_agree').on('click', this.handleAgreeClick);
  },

  render() {
    const { $el, model } = this;
    $el.attr({ class: `${this.pfx}myConversation`, id: 'myConversation' });
    this.renderContent();
    return this;
  }
});
